import { createContext } from 'react';

import { CarQuotationCoverage, MultiplicativeFactors } from '../../../../../../../../../shared/interfaces';
import { CoverageDetailByCode } from './StepThreeFormProvider';

interface StepThreeFormContextProps {  

  allCoveragesDetailsByCode:                        CoverageDetailByCode[];

  //* Methods:

  getMultiplicativeFactorsPerCoverageByVehicle:     (componentId: string, coverageCode: string) => Array<MultiplicativeFactors> | undefined;

  getInsuredSumaPerVehicle:                         (componentId: string) => number;

  getSelectedCoverageByDefault:                     (componentId: string) => CarQuotationCoverage;

  autoSelectHighestPrizeCoverage:                   (componentId: string) => Promise<void>;

  getDetailCoverage:                                (coverageCode: string) => Promise<void>;
}

export const StepThreeFormContext = createContext(
  {} as StepThreeFormContextProps
);
